<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Review</h1>
        </template>

        <div class="mb-4 flex justify-between items-center ">
            <div>
                <p class="font-bold">Batched Delivery</p>
                <p class="hidden md:inline-block text-sm text-gray-darker">
                    Emails are collected and delivered to you in batches per your delivery schedule.
                </p>
            </div>
            <p-check class="p-switch p-fill flex-shrink-0" color="primary" v-model="settings.batched_delivery" disabled></p-check>
        </div>

        <div class="mb-4 flex justify-between items-center ">
            <div>
                <p class="font-bold">VIP List</p>
                <p class="hidden md:inline-block text-sm text-gray-darker">
                    Emails matching any of your VIPs will be delivered immediately.
                </p>
            </div>
            <p-check class="p-switch p-fill flex-shrink-0" color="primary" v-model="settings.vip" disabled></p-check>
        </div>
        
        <div class="flex justify-between items-center ">
            <div>
                <p class="font-bold">Daily Digest</p>
                <p class="hidden md:inline-block text-sm text-gray-darker">
                    <span v-if="settings.daily_digest">Emails from first-time senders will be held back from your inbox for your review later on.</span>
                    <span v-else>All emails will be delivered to your inbox.</span>
                    This setting can be changed afterwards as well.
                </p>
            </div>
            <p-check class="p-switch p-fill flex-shrink-0" color="primary" v-model="settings.daily_digest"></p-check>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col">
                <span class="text-sm my-2">
                    <p-check name="check" color="primary" class="p-default p-curve" v-model="settings.remember">Remember these and do not ask again.</p-check>
                </span>
                <button class="py-2 px-4 rounded-md bg-primary text-white" @click="submit">Activate Mailman</button>
            </div>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        mailbox: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            settings: {
                batched_delivery: true,
                vip             : true,
                daily_digest    : this.mailbox.is_filtering_spam,
                remember        : !this.mailbox.confirm_when_activating,
            }
        }
    },
    methods: {
        submit() {
            this.$emit('resolve', this.settings)
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>